// src/components/Testimonial.js (Updated with multiple testimonials)

import React from 'react';
import './Testimonial.css'; 
import { Link } from 'react-router-dom'; 
import { motion } from 'framer-motion'; // <-- Framer Motion Import

const testimonialsData = [
    {
        quote: "As a student juggling coursework and career anxiety, Blue Print gave me the exact, sequenced guidance I needed to start building my portfolio without wasting time.",
        author: "Sarah M.",
        title: "Computer Science Student",
        source: "College Student",
    },
    {
        quote: "Training takes up all my time. This platform cut through the noise, providing high-quality, targeted business resources I could consume quickly during my off-season.",
        author: "David K.",
        title: "Professional Athlete (NFL)",
        source: "Athlete",
    },
    {
        quote: "I needed to monetize, but I didn't know how to structure my growth. The personalized roadmap here helped me turn my hobby into a scalable media business.",
        author: "Leo J.",
        title: "Full-Time Streamer & Influencer",
        source: "Content Creator",
    },
];

// =======================================
// FRAMER MOTION VARIANTS
// =======================================

// Container variant for the grid
const containerVariants = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            delayChildren: 0.2,   
            staggerChildren: 0.1, 
        }
    }
};

// Item variant for each testimonial card
const itemVariants = {
    hidden: { y: 25, opacity: 0 },
    show: {
        y: 0,
        opacity: 1,
        transition: {
            duration: 0.4, 
            ease: "easeOut"
        }
    }
};


const Testimonial = () => {
    return (
        <section className="testimonial-section section-padding">
            <h2 className="section-heading">Why Users Trust Blue Print</h2>
            
            <motion.div 
                className="testimonials-grid main-content"
                variants={containerVariants}
                initial="hidden"
                // Trigger animation when component enters the viewport
                whileInView="show" 
                // Ensures animation runs once when 50% visible
                viewport={{ once: true, amount: 0.5 }} 
            >
                {testimonialsData.map((t, index) => (
                    // Use motion.div for each card and apply item variant
                    <motion.div 
                        key={index} 
                        className="testimonial-card glossy-card"
                        variants={itemVariants}
                    >
                        <blockquote className="testimonial-quote">
                            "{t.quote}"
                        </blockquote>
                        <p className="testimonial-author">
                            — **{t.author}**
                        </p>
                        <p className="testimonial-title">
                            {t.title} <span className="source-tag">({t.source})</span>
                        </p>
                    </motion.div>
                ))}
            </motion.div>
            
            {/* Final CTA at the bottom of the section */}
            <div className="testimonial-cta-wrapper">
                 <Link to="/onboarding" className="btn-primary">
                    Start Building Your Roadmap Now
                 </Link>
            </div>
        </section>
    );
};

export default Testimonial;